import { lazy } from "react";
import LandingPage from "../pages/landing";

const Shop = lazy(() => import("../pages/Shop"));
const Login = lazy(() => import("../pages/Login"));
const ProductDetail = lazy(() => import("../pages/ProductDetail"));
const Checkout = lazy(() => import("../pages/Checkout"));
const OrderSuccess = lazy(() => import("../pages/OrderSuccess"));
const UserProfile = lazy(() => import("../components/UserProfile"));
const ForgotPassword = lazy(() => import("../components/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/ResetPassword"));
const AdminDashboard = lazy(() => import("../pages/admin/Dashboard/index"));
const WalletPage = lazy(() => import("../pages/WalletPage"));
const ProfileComplete = lazy(() => import("../pages/ProfileComplete"));
const Wishlist = lazy(() => import("../pages/Wishlist"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("../pages/TermsOfService"));
const CookiePolicy = lazy(() => import("../pages/CookiePolicy"));
const RefundPolicy = lazy(() => import("../pages/RefundPolicy"));
const ShippingPolicy = lazy(() => import("../pages/ShippingPolicy"));
const AcceptableUsePolicy = lazy(() => import("../pages/AcceptableUsePolicy"));

export const routeConfig = [
  { path: "/", component: LandingPage },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgotPassword },
  { path: "/reset-password", component: ResetPassword },
  { path: "/shop", component: Shop },
  { path: "/product/:productId", component: ProductDetail },
  { path: "/checkout", component: Checkout },
  { path: "/order-success/:orderId", component: OrderSuccess },
  { path: "/profile", component: UserProfile, requiresAuth: true },
  { path: "/user/profile", component: UserProfile, requiresAuth: true },
  { path: "/wallet", component: WalletPage, requiresAuth: true },
  { path: "/profile-complete", component: ProfileComplete, requiresAuth: true },
  { path: "/wishlist", component: Wishlist, requiresAuth: true },
  { path: "/admin", component: AdminDashboard, requiresAdmin: true },
  { path: "/privacy", component: PrivacyPolicy },
  { path: "/terms", component: TermsOfService },
  { path: "/cookies", component: CookiePolicy },
  { path: "/refund", component: RefundPolicy },
  { path: "/shipping", component: ShippingPolicy },
  { path: "/acceptable-use", component: AcceptableUsePolicy },
];

export default routeConfig;
